import { SiteNav } from "@/components/SiteNav";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { Manifesto } from "@/components/Manifesto";
import { MenuSection } from "@/components/MenuSection";
import { Gallery } from "@/components/Gallery";
import { OrderSection } from "@/components/OrderSection";
import { Outlets } from "@/components/Outlets";
import { Reviews } from "@/components/Reviews";
import { ContactSection } from "@/components/ContactSection";

export default function Home() {
  return (
    <>
      <Hero />
      <Marquee />
      <Manifesto />
      <MenuSection />
      <Gallery />
      <OrderSection />
      <Outlets />
      <Reviews />
      <ContactSection />
    </>
  );
}
